import DetailFormHead from "components/subHead/detailFormHead";
import BaseInfForm from "../baseInfForm";
import { useGetData } from "../service";
import { useTranslation } from "react-i18next";
import NoInf from "components/noInf";
import RoomImg from "./roomImg";
import { RoomImageProvider } from "../context";
import MultilingualForm from "../multilingualForm";

export default function RoomDetail() {
  const { t } = useTranslation();
  const { baseInf, addInf, imgList } = useGetData({ modalNm: "detail" });
  return (
    <>
      {/* 기본정보 상세 */}
      <DetailFormHead title={t("row_ttl_default")} />
      {!baseInf && <BaseInfForm baseInf={null} formTyp={"read"} />}
      {baseInf && <BaseInfForm baseInf={baseInf} formTyp={"read"} />}

      {/* 추가정보 상세 */}
      <DetailFormHead title={t("row_ttl_add_inf")} />
      <div>
        {addInf.length === 0 && <NoInf />}
        {addInf.length !== 0 &&
          addInf.map((inf: any) => {
            return <MultilingualForm inf={inf} formTyp={"read"} formId={""} />;
          })}

        {/* 객실이미지 */}
      </div>
      <DetailFormHead title={t("row_ttl_rm_img")} />
      <RoomImageProvider>
        <RoomImg imgList={imgList} />
      </RoomImageProvider>
    </>
  );
}
